/*
  smb-chip-pack.js — packs a row of chips into as few lines as they fit, so
  a short chip fills the gap a long one left at the end of a line (Sam,
  2026-09-30: "we can be smarter on the tiling ... like tiles easily could
  fit against mattresses").

  A [data-chip-pack] container (the Built for tags on the product page and
  Shop all rows) keeps its chips in admin order until this runs. Then each
  chip is measured at its own width, and the chips are placed longest first,
  each into the first line with room for it (first-fit decreasing), and put
  back into the DOM in that order, a row per line, so keyboard order follows
  what is seen.
  The chips still grow to fill their line (brand.css), so every line runs
  edge to edge. It packs again whenever the container's width changes.

  The labels are a set, not a sequence: which comes first says nothing, so
  reordering them loses nothing. A file, not an inline script, for the
  Section Rendering reason in CLAUDE.md ("Bundles"). Without JavaScript the
  chips wrap in admin order, as before.
*/
(function () {
  'use strict';
  if (window.smbChipPack) return;

  function unwrap(box) {
    var lines = box.querySelectorAll(':scope > .smb-chip-line');
    for (var i = 0; i < lines.length; i++) {
      while (lines[i].firstChild) box.insertBefore(lines[i].firstChild, lines[i]);
      box.removeChild(lines[i]);
    }
    box.classList.remove('is-packed');
  }

  function pack(box) {
    unwrap(box);
    var chips = Array.prototype.slice.call(box.children);
    if (chips.length < 3) return;
    var width = box.clientWidth;
    if (!width) return;
    var gap = parseFloat(getComputedStyle(box).columnGap) || 0;

    // Each chip at its own width: growth off while measuring.
    box.classList.add('is-packing');
    var sized = chips.map(function (el, i) {
      return { el: el, w: Math.ceil(el.getBoundingClientRect().width), i: i };
    });
    box.classList.remove('is-packing');

    // Longest first; equal widths keep admin order.
    sized.sort(function (a, b) {
      return b.w - a.w || a.i - b.i;
    });
    // How many lines they need: first-fit decreasing, each chip into the
    // first line with room.
    var lines = firstFit(sized, width, gap);
    // Then spread them evenly over that many lines, each chip onto the line
    // with least in it, so no line is left with one short chip on it (a
    // chip grows to half the row at most, so a lone short one cannot fill
    // its line). Kept only if every chip fits.
    var even = balance(sized, lines.length, width, gap);
    if (even) lines = even;

    // Each line gets its own row: left to the browser's own wrapping, a
    // chip from the next line is pulled up wherever it fits, which undoes
    // the balance. Within a line, admin order.
    lines.forEach(function (line) {
      line.items.sort(function (a, b) {
        return a.i - b.i;
      });
      var row = document.createElement('div');
      row.className = 'smb-chip-line';
      line.items.forEach(function (c) {
        row.appendChild(c.el);
      });
      box.appendChild(row);
    });
    box.classList.add('is-packed');
  }

  function firstFit(sized, width, gap) {
    var lines = [];
    sized.forEach(function (c) {
      for (var n = 0; n < lines.length; n++) {
        if (lines[n].used + gap + c.w <= width + 0.5) {
          lines[n].used += gap + c.w;
          lines[n].items.push(c);
          return;
        }
      }
      lines.push({ used: c.w, items: [c] });
    });
    return lines;
  }

  function balance(sized, count, width, gap) {
    var lines = [];
    for (var n = 0; n < count; n++) lines.push({ used: 0, items: [] });
    for (var i = 0; i < sized.length; i++) {
      var c = sized[i];
      var best = null;
      for (var k = 0; k < lines.length; k++) {
        var add = lines[k].items.length ? gap + c.w : c.w;
        if (lines[k].used + add > width + 0.5) continue;
        if (!best || lines[k].used < best.used) best = lines[k];
      }
      if (!best) return null;
      best.used += best.items.length ? gap + c.w : c.w;
      best.items.push(c);
    }
    return lines;
  }

  var observer =
    'ResizeObserver' in window
      ? new ResizeObserver(function (entries) {
          entries.forEach(function (entry) {
            var box = entry.target;
            var w = Math.round(entry.contentRect.width);
            if (box.__smbPackW === w) return;
            box.__smbPackW = w;
            pack(box);
          });
        })
      : null;

  function watch(root) {
    var boxes = (root || document).querySelectorAll('[data-chip-pack]');
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].__smbPack) continue;
      boxes[i].__smbPack = true;
      pack(boxes[i]);
      if (observer) observer.observe(boxes[i]);
    }
  }

  function repackAll() {
    var boxes = document.querySelectorAll('[data-chip-pack]');
    for (var i = 0; i < boxes.length; i++) pack(boxes[i]);
  }

  window.smbChipPack = { watch: watch, repack: repackAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      watch();
    });
  } else {
    watch();
  }
  // The chips measure again once the web fonts are in.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(repackAll);
  // Rows swapped in by the shop filter or appended by Load more.
  document.addEventListener('smb:section:refresh', function () {
    watch();
  });
  document.addEventListener('shopify:section:load', function (e) {
    watch(e.target);
  });
})();
